import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { JobsListTypes } from 'src/app/job/constants/job-detail.constants';
import { JobDetailAttachment } from 'src/app/job/models/job-detail/job-detail-attachment.model';
import { AttachmentFileTypes } from '../../constants/file.constants';
import { AttachmentType } from '../../models/Enums';
import { Attachment } from '../../models/uploaded-file-list.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-file-list-viewer',
  templateUrl: './file-list-viewer.component.html',
  styleUrls: ['./file-list-viewer.component.scss'],
})
export class FileListViewerComponent implements OnInit {
  fileList: AttachmentFile[] = [];
  @Input() showremoveFile = false;
  imageList: JobDetailAttachment[] = [];
  @Input() isReadOnly = false;
  @Input() showBeforeAfterTag = false;
  @Input() set files(value: any[]) {
    this.fileList = [];
    this.imageList =[];
    if (value) {
      for (let i = 0; i < value.length; i++) {
        this.processFiles(value[i]);
        this.loadFiles();
      }
      
    }
  }

  @Input() set file(value: any) {
    this.fileList = [];
    this.imageList =[];
    if (value) {
        this.processFiles(value);
        this.loadFiles();
    }
  }
  AttachmentType = AttachmentType;
  @Input() attachmentType: AttachmentType;
  @Input() jobId: string;
  @Input() jobListType: JobsListTypes = JobsListTypes.None;
  @Output() removeFile = new EventEmitter<AttachmentFile>();
  isOpenImageDrawer: boolean = false;
  isOpenPdfDrawer: boolean = false;
  isOpenVideoDrawer: boolean = false;
  isImageEditor: boolean = false;
  attachmentTypeEnum: typeof AttachmentType = AttachmentType;
  fileSelected: any;
  attDetails: Attachment;
  constructor(private bottomSheet: MatBottomSheet) {}

  ngOnInit(): void {}

  loadFiles(): void {
    for (let i = 0; i < this.fileList.length; i++) {
      //If file extension not found
      if (!this.fileList[i].extension) {
        this.fileList[i].extension = this.getFileExtension(
          this.fileList[i].blobUrl
        );
      }
      this.fileList[i].type = this.getFileType(this.fileList[i].extension);
      if (this.fileList[i].type == AttachmentFileTypes.Images) {
        this.fileList[i].isImage = true;
      } else if (this.fileList[i].type == AttachmentFileTypes.Videos) {
        this.fileList[i].isVideo = true;
      } else {
        this.fileList[i].isOther = true;
        if (this.fileList[i].extension.toLowerCase() == '.pdf') this.fileList[i].isPdf = true;
        if (this.fileList[i].extension.toLowerCase() == '.csv') this.fileList[i].isCsv = true;
        if (this.fileList[i].extension.toLowerCase() == '.msg') this.fileList[i].isMsg = true;
        if (this.fileList[i].extension.toLowerCase() == '.eml') this.fileList[i].isEml = true;
        if (this.fileList[i].extension.toLowerCase() == '.tiff')
          this.fileList[i].isTiff = true;
      }
    }
  }

  getFileExtension(url: string): string {
    return url.split('.').pop().toLowerCase().trim();
  }
  

  getFileType(extension: string): AttachmentFileTypes {
    if (extension === undefined || extension === null) {
      return null;
    }
    switch (extension.toLowerCase()) {
      case '.jpg':
      case '.jpeg':
      case '.png':
      case '.gif':
        return AttachmentFileTypes.Images;
      case '.mp4':
      case '.wmv':
      case '.avi':
      case '.mov':
      case '.3gp':
      case '.flv':
      case '.m3u8':
      case '.ts':
        return AttachmentFileTypes.Videos;
        case '.pdf':
          return AttachmentFileTypes.Pdf
    }
    return AttachmentFileTypes.Other;
  }

  download(url: string): void {
    const filename = url.substring(url.lastIndexOf('/') + 1);
    const request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.responseType = 'blob';
    request.onload = function () {
      if (this.status === 200) {
        var file = window.URL.createObjectURL(this.response);
        var a = document.createElement('a');
        a.href = file;
        a.download = filename || 'Attachment';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    };
    request.send();
  }

  openPdf(att: Attachment): void {
    this.fileSelected = att.blobUrl+ '?page=1';
    this.isOpenPdfDrawer = true;
  }

  viewVideo(att: Attachment): void {
    this.fileSelected = att.blobUrl;
    this.isOpenVideoDrawer = true;
  }

  viewImage(att: Attachment): void {
    //this.file = att.blobUrl;
    this.attDetails = att;
    this.isOpenImageDrawer = true;
    this.isImageEditor = false;
  }
  editImage(att: Attachment): void {
    this.isOpenImageDrawer = true;
    this.isImageEditor = true;
    this.attDetails = att;
  }
  closeImageDrawer(): void {
    this.isOpenImageDrawer = false;
    this.isImageEditor = false;
    this.fileSelected = null;
    this.attDetails = null;
  }
  closePdfDrawer(): void {
    this.isOpenPdfDrawer = false;
    this.fileSelected = null;
  }
  closeVideoDrawer(): void {
    this.isOpenVideoDrawer = false;
    this.fileSelected = null;
  }
  isShowAsQuoteAttachment(file: AttachmentFile) {
    return (
      (file.isAfter && this.jobListType == JobsListTypes.UnscheduledJobs) ||
      this.jobListType == JobsListTypes.VariationAvailableJobs ||
      this.jobListType == JobsListTypes.QuotedJobs ||
      this.jobListType == JobsListTypes.TradePosted ||
      this.jobListType == JobsListTypes.PendingOwnerApprovalJobs
    );
  }

  deleteFile(file: any) {
    this.removeFile.emit(file);
  }
  getOriginalImageAttachment(attachment: Attachment) {
    return this.imageList.find((i) => i.fileUrl == attachment.blobUrl);
  }

 private processFiles(value : any){
    let attFile = new AttachmentFile();
    attFile.name = value.fileName;
    attFile.blobUrl = value.fileUrl
      ? value.fileUrl
      : value.blobUrl;
    attFile.blobName = value.fileName;
    attFile.extension = value.extension;
    attFile.comment = value.comment;
    attFile.attachmentType = value.attachmentType;
    attFile.isAfter = value.isAfter;
    this.fileList.push(attFile);
    if(this.getFileType(value.extension) == AttachmentFileTypes.Images){
       var attachmentDetail  : JobDetailAttachment = value;
       attachmentDetail.fileUrl = value?.fileUrl ? value.fileUrl: value.blobUrl;
       attachmentDetail.fileId = value?.fileId ? value.fileId: value.blobName?.split('.')[0];
      this.imageList.push(attachmentDetail)
    }
  }
  isImage(file: any): boolean {
    return this.getFileType(file.extension) === AttachmentFileTypes.Images || this.getFileType(file.extension) === AttachmentFileTypes.Pdf;
  }
  
  
}

class AttachmentFile {
  name: string;
  blobName?: string;
  blobUrl?: string;
  extension: string;
  type: AttachmentFileTypes;
  isImage?: boolean;
  isVideo?: boolean;
  isPdf?: boolean;
  isCsv?: boolean;
  isMsg?: boolean;
  isEml?: boolean;
  isTiff?: boolean;
  isOther?: boolean;
  comment: string;
  attachmentType: AttachmentType;
  isAfter: boolean;

  getId() {
    return this.blobName.substring(0, this.blobName.lastIndexOf('.'));
  }
}
